var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.getters.userRole === 'top_agent')?_c('top-agent-self-stop'):(this.$store.getters.userRole === 'agency')?_c('agency-self-stop'):(this.$store.getters.userRole === 'merchant')?_c('merchant-self-stop'):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }